var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"position-relative cover-contents px-3"},[_c('p',{staticClass:"title-1 mx-auto text-white"},[_vm._v("Our Vendors")]),_c('p',{staticClass:"subtitle-1 mx-auto mb-0 text-white"},[_vm._v("Take a look at all the current vendors on Ordo")])])])
}]

export { render, staticRenderFns }